import { useQuery } from "@apollo/client";
import { FETCH_DOCUMENTS_LIST } from "@documents/graphql/queries/fetchDocumentsList";
import { useMemo } from "react";
import { filterLatestDocuments } from "@utils/documentVersion";

export interface Document {
    id: string;
    name: string;
    reference?: string;
    category?: string;
    version_major?: number;
    version_minor?: number;
    hoverTitle?: string;
    isActiveForCompany?: boolean;
    metadata?: any;
    rootContentNode?: {
        id: string;
        type: string;
        childNodes?: Array<{
            id: string;
            type: string;
            text?: string;
            metadata?: any;
        }>;
    };
}

export const useDocumentsList = (skip = false) => {
    const { data, loading, error } = useQuery(FETCH_DOCUMENTS_LIST, {
        skip,
        errorPolicy: "all", // capture GraphQL errors without throwing
    });
    
    // Memoize documents array to avoid new reference each render when unchanged
    const documents = useMemo(() => {
        const allDocs = (data?.officialDocuments || []) as Document[];
        return filterLatestDocuments(allDocs);
    }, [data?.officialDocuments]);

    return {
        documents,
        loading,
        error,
    };
}; 